/* eslint-disable react-hooks/rules-of-hooks */
import {
  Box,
  Flex,
  Text,
  IconButton,
  Stack,
  Collapse,
  Icon,
  Popover,
  PopoverTrigger,
  PopoverContent,
  useColorModeValue,
  useBreakpointValue,
  useDisclosure,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
} from '@chakra-ui/react';
import {
  HamburgerIcon,
  CloseIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  SettingsIcon,
  InfoIcon,
} from '@chakra-ui/icons';

import ColorModeSwitcher from './ColorModeSwitcher'
import { Link, withRouter } from 'react-router-dom';
import React from 'react';
import { HTTPClient } from '../utils';
import Loader from './Loader'

function Header({ history }) {
  const { isOpen, onToggle } = useDisclosure();
  const authToken = localStorage.getItem("authToken");

  const [credits, setCredits] = React.useState(null)
  const [fetchingCredits, setFetchingCredits] = React.useState(false)

  const showCreditsInfo = !fetchingCredits && authToken && credits
  React.useEffect(() => {
    getCreditsInfo()
  }, [authToken])

  const getCreditsInfo = () => {
    if (!authToken) {
      return;
    }
    setFetchingCredits(true);
    HTTPClient.GET('/search/credits')
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }
        setFetchingCredits(false)
      })
      .then(jsonResponse => {
        const { data = {} } = jsonResponse
        const { credits: creditBalance = 0 } = data
        setFetchingCredits(false)
        setCredits(creditBalance)
      })
      .catch(() => setFetchingCredits(false));
  };

  if (authToken) {
    NAV_ITEMS = [
      {
        label: 'Quick Search',
        href: '/quick-search',
      },
      {
        label: 'Bulk Search',
        href: '/bulk-search',
      }
    ]
  }
  return (
    <Box>
      <Flex
        bg={useColorModeValue('white', 'gray.800')}
        color={useColorModeValue('gray.600', 'white')}
        minH={'60px'}
        py={{ base: 2 }}
        px={{ base: 4 }}
        borderBottom={1}
        borderStyle={'solid'}
        borderColor={useColorModeValue('gray.200', 'gray.900')}
        align={'center'}>
        <Flex
          flex={{ base: 1, md: 'auto' }}
          ml={{ base: -2 }}
          display={{ base: 'flex', md: 'none' }}
          visibility={NAV_ITEMS.length === 0 ? 'hidden' : 'visible'}>
          <IconButton
            onClick={onToggle}
            icon={
              isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />
            }
            variant={'ghost'}
            aria-label={'Toggle Navigation'}
          />
        </Flex>
        <Flex flex={{ base: 1 }} justify={{ base: 'center', md: 'start' }}>
          <Text
            textAlign={useBreakpointValue({ base: 'center', md: 'left' })}
            fontFamily={'heading'}
            color={useColorModeValue('gray.800', 'white')}>
            e91
            </Text>

          <Flex display={{ base: 'none', md: 'flex' }} ml={10}>
            <DesktopNav />
          </Flex>
        </Flex>

        <Stack
          flex={{ base: 1, md: 0 }}
          justify={'flex-end'}
          direction={'row'}
          spacing={6}>

          {authToken && (
            <>
              {fetchingCredits && <div style={{ marginTop: '5px' }}>
                <Loader size="lg" />
              </div>}
              {showCreditsInfo && (
                <Button leftIcon={<InfoIcon />}
                  bg={'blue.400'}
                  color={'white'}
                  _hover={{
                    bg: 'blue.500',
                  }}
                >
                  {credits}
                </Button>
              )}
            </>
          )}
          <ColorModeSwitcher />

          {authToken &&
            <Menu>
              <MenuButton>
                <IconButton icon={<SettingsIcon />} />
              </MenuButton>
              <MenuList>
                {/* <MenuItem onClick={() => history.push("/settings")}>
                  Settings
                </MenuItem> */}
                <MenuItem onClick={() => {
                  NAV_ITEMS = []
                  localStorage.clear()
                  history.push('/login');
                }}>Logout</MenuItem>
              </MenuList>
            </Menu>
          }

        </Stack>
      </Flex>

      <Collapse in={isOpen} animateOpacity>
        <MobileNav />
      </Collapse>
    </Box>
  );
}

const DesktopNav = () => {
  return (
    <Stack direction={'row'} spacing={4}>
      {NAV_ITEMS.map((navItem) => (
        <Box key={navItem.label}>
          <Popover trigger={'hover'} placement={'bottom-start'}>
            <PopoverTrigger>
              <Link
                p={2}
                to={navItem.href}
                fontSize={'sm'}
                fontWeight={500}
                color={useColorModeValue('gray.600', 'gray.200')}
                _hover={{
                  textDecoration: 'none',
                  color: useColorModeValue('gray.800', 'white'),
                }}>
                {navItem.label}
              </Link>
            </PopoverTrigger>

            {navItem.children && (
              <PopoverContent
                border={0}
                boxShadow={'xl'}
                bg={useColorModeValue('white', 'gray.800')}
                p={4}
                rounded={'xl'}
                minW={'sm'}>
                <Stack>
                  {navItem.children.map((child) => (
                    <DesktopSubNav key={child.label} {...child} />
                  ))}
                </Stack>
              </PopoverContent>
            )}
          </Popover>
        </Box>
      ))}
    </Stack>
  );
};

const DesktopSubNav = ({ label, href, subLabel }) => {
  return (
    <Link
      to={href}
      role={'group'}
      display={'block'}
      p={2}
      rounded={'md'}
      _hover={{ bg: useColorModeValue('pink.50', 'gray.900') }}>
      <Stack direction={'row'} align={'center'}>
        <Box>
          <Text
            transition={'all .3s ease'}
            _groupHover={{ color: 'pink.400' }}
            fontWeight={500}>
            {label}
          </Text>
          <Text fontSize={'sm'}>{subLabel}</Text>
        </Box>
        <Flex
          transition={'all .3s ease'}
          transform={'translateX(-10px)'}
          opacity={0}
          _groupHover={{ opacity: '100%', transform: 'translateX(0)' }}
          justify={'flex-end'}
          align={'center'}
          flex={1}>
          <Icon color={'pink.400'} w={5} h={5} as={ChevronRightIcon} />
        </Flex>
      </Stack>
    </Link>
  );
};

const MobileNav = () => {
  return (
    <Stack
      bg={useColorModeValue('white', 'gray.800')}
      p={4}
      display={{ md: 'none' }}>
      {NAV_ITEMS.map((navItem) => (
        <MobileNavItem key={navItem.label} {...navItem} />
      ))}
    </Stack>
  );
};

const MobileNavItem = ({ label, children, href }) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <Stack spacing={4} onClick={children && onToggle}>
      <Flex
        py={2}
        as={Link}
        to={href}
        justify={'space-between'}
        align={'center'}
        _hover={{
          textDecoration: 'none',
        }}>
        <Text
          fontWeight={600}
          color={useColorModeValue('gray.600', 'gray.200')}>
          {label}
        </Text>
        {children && (
          <Icon
            as={ChevronDownIcon}
            transition={'all .25s ease-in-out'}
            transform={isOpen ? 'rotate(180deg)' : ''}
            w={6}
            h={6}
          />
        )}
      </Flex>

      <Collapse in={isOpen} animateOpacity style={{ marginTop: '0!important' }}>
        <Stack
          mt={2}
          pl={4}
          borderLeft={1}
          borderStyle={'solid'}
          borderColor={useColorModeValue('gray.200', 'gray.700')}
          align={'start'}>
          {children &&
            children.map((child) => (
              <Link key={child.label} py={2} to={child.href}>
                {child.label}
              </Link>
            ))}
        </Stack>
      </Collapse>
    </Stack>
  );
};

export default withRouter(Header)
let NAV_ITEMS = [
  // {
  //   label: 'Spamcall Profiler',
  //   children: [
  //     {
  //       label: 'Quick search',
  //       subLabel: 'Quick filter for upto 50 numbers',
  //       href: '#',
  //     },
  //     {
  //       label: 'Bulk search',
  //       subLabel: 'Queue your large excel files here',
  //       href: '#',
  //     },
  //   ],
  // },
  // {
  //   label: 'Find Work',
  //   children: [
  //     {
  //       label: 'Job Board',
  //       subLabel: 'Find your dream design job',
  //       href: '#',
  //     },
  //     {
  //       label: 'Freelance Projects',
  //       subLabel: 'An exclusive list for contract work',
  //       href: '#',
  //     },
  //   ],
  // },
  // {
  //   label: 'Quick Search',
  //   href: '/quick-search',
  // },
  // {
  //   label: 'Bulk Search',
  //   href: '/bulk-search',
  // }
];